import { useEffect, useState } from "react";
import axios from "axios";
import { FilePdf, ArrowSquareOut, Article } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ASSET_BASE = process.env.REACT_APP_BACKEND_URL || "";
const resolveUrl = (u) => !u ? "" : (u.startsWith("http") ? u : `${ASSET_BASE}/${u.replace(/^\/+/, "")}`);

export default function PapersList({ type = "research" }) {
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let m = true;
    axios.get(`${API}/research-papers`, { params: { type } })
      .then((r) => m && setPapers(r.data?.papers || []))
      .catch(() => m && setPapers([]))
      .finally(() => m && setLoading(false));
    return () => { m = false; };
  }, [type]);

  if (loading) return <p className="text-stone-500 text-sm">Loading papers…</p>;

  if (papers.length === 0) {
    return (
      <div className="bg-stone-900/40 rounded-2xl border border-stone-800/60 p-8 text-center"
           data-testid="papers-empty">
        <Article size={32} className="text-stone-600 mx-auto mb-2" />
        <p className="text-sm text-stone-400">No papers published yet. Check back soon.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="papers-list">
      {papers.map((p) => (
        <div key={p.id} className="bg-stone-900 rounded-xl border border-stone-800 p-5 hover:border-emerald-700/40 transition-colors"
             data-testid={`paper-${p.id}`}>
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-lg bg-emerald-600/20 flex items-center justify-center shrink-0">
              <FilePdf size={18} weight="duotone" className="text-emerald-400" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-heading text-base font-semibold text-white">{p.title}</p>
              {p.authors && <p className="text-xs text-stone-500 mt-0.5">{p.authors}</p>}
              {p.abstract && <p className="text-sm text-stone-400 mt-2 leading-relaxed">{p.abstract}</p>}
              <div className="flex flex-wrap gap-2 mt-3">
                {p.pdf_url && (
                  <a href={resolveUrl(p.pdf_url)} target="_blank" rel="noreferrer"
                    className="inline-flex items-center gap-1.5 bg-emerald-600 hover:bg-emerald-700 text-white text-xs px-3 py-1.5 rounded-lg"
                    data-testid={`paper-pdf-${p.id}`}>
                    <FilePdf size={12} weight="bold" /> Download PDF
                  </a>
                )}
                {p.external_url && (
                  <a href={p.external_url} target="_blank" rel="noreferrer"
                    className="inline-flex items-center gap-1.5 bg-stone-800 border border-stone-700 hover:bg-stone-700 text-stone-200 text-xs px-3 py-1.5 rounded-lg"
                    data-testid={`paper-ext-${p.id}`}>
                    External link <ArrowSquareOut size={11} />
                  </a>
                )}
                {p.published_at && (
                  <span className="text-[10px] text-stone-500 self-center">
                    {new Date(p.published_at).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
